import styled from 'styled-components';
import { MdEdit, MdAdd, MdOutlineRemoveCircle } from 'react-icons/md';
import Bg1 from '../../Images/Profile/bg-1.jpg';

export const AccountContainer = styled.div`
background: #F0FFE6;
width: 100%;
height: 100%;
position: relative;
`;

export const AccountWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 50px 25px;
`;

export const ProfileWrapper = styled.div`
background: #fff;
border-radius: 10px;
box-shadow: 5px 5px rgba(136, 136, 136, 0.1);
width: 100%;
margin-bottom : 25px;
`;

export const AccountTop = styled.div`
display: flex;
height: 200px;
width: 100%;
border-radius: 10px 10px 0 0;
background: linear-gradient( to bottom, rgba(255, 255, 255, 0.1) 20%, rgba(255, 255, 255, 1) 100%), url(${Bg1});
background-repeat: no-repeat;
background-size: cover;
`;

export const AccountHeader = styled.h3`
font-size: 36px;
color: #fff;
margin: auto;
text-shadow: 2px 2px #888888;
`;

export const AccountTextWrapper = styled.div`
display: flex;
flex-direction: column;
padding: 25px;
`;

export const AccountLabel = styled.p`
font-size: 18px;
color: #808080;
font-weight: 300;

@media screen and (max-width: 768px){
    font-size: 16px;
}

@media screen and (max-width: 480px){
    font-size: 14px;
}
`;

export const AccountInfoText = styled.p`
font-size: 18px;
color: #000;
font-weight: 500;
margin-left: 10px;

@media screen and (max-width: 768px){
    font-size: 16px;
    margin-left: 0;
}

@media screen and (max-width: 480px){
    font-size: 14px;
    margin-left: 0;
}
`;

export const AccountDivider = styled.div`
width: 100%;
border-top: 1px solid #F5F5F5;
margin: 10px 0;
`;

export const SmallHeader = styled.h4`
font-size: 24px;
color: #000;

@media screen and (max-width: 768px){
    font-size: 22px;
}

@media screen and (max-width: 480px){
    font-size: 18px;
}
`;

export const InfoWrapper = styled.div`
display: flex;
flex-direction: row;

@media screen and (max-width: 768px){
    flex-direction: column;
}
`;

export const SmallHeaderWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
`;

export const EditText = styled.button`
display: flex;
font-size: 14px;
color: #619657;
margin-right: 5px;
border: none;
background: none;
justify-content: center;
align-items: center;

&:hover {
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    transform: scale(1.05);
}

@media screen and (max-width: 768px){
    font-size: 12px;
}

@media screen and (max-width: 480px){
    font-size: 11px;
}
`;

export const EditIcon = styled(MdEdit)`
margin-left: 5px;
font-size: initial;
`;

export const AddIcon = styled(MdAdd)`
margin-left: 5px;
font-size: initial;
`;

export const RemoveIcon = styled(MdOutlineRemoveCircle)`
margin-left: 5px;
font-size: initial;
`;

export const WalletWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;

@media screen and (max-width: 768px){
    flex-direction: column;
}
`;

export const WalletText = styled.button`
display: flex;
font-size: 14px;
color: #619657;
margin-right: 5px;
border: none;
background: none;
justify-content: center;
align-items: center;

&:hover {
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    transform: scale(1.05);
}

@media screen and (max-width: 768px){
    font-size: 12px;
    justify-content: flex-start;
    align-items: flex-start;
}

@media screen and (max-width: 480px){
    font-size: 11px;
    justify-content: flex-start;
    align-items: flex-start;
}
`;
